module.exports = __webpack_public_path__ + "static/media/meditation.0820c1a3.jpg";